"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRollbarConstructorFromContext = getRollbarConstructorFromContext;
exports.getRollbarFromContext = getRollbarFromContext;
exports.Provider = exports.Context = void 0;

var _rollupPluginBabelHelpersE84dd01a = require("./_rollupPluginBabelHelpers-e84dd01a.js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _rollbar = _interopRequireDefault(require("rollbar"));

var _tinyInvariantEsmA43f84cc = require("./tiny-invariant.esm-a43f84cc.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Context = /*#__PURE__*/(0, _react.createContext)();
exports.Context = Context;
Context.displayName = 'Rollbar';
var RollbarInstance = Symbol('RollbarInstance');
var BaseOptions = Symbol('BaseOptions');
var RollbarCtor = Symbol('RollbarCtor');

function getRollbarFromContext(context) {
  var rollbar = context[RollbarInstance];
  return rollbar;
}

function getRollbarConstructorFromContext(context) {
  var ctor = context[RollbarCtor];
  return ctor;
}

var Provider = /*#__PURE__*/function (_Component) {
  (0, _rollupPluginBabelHelpersE84dd01a.b)(Provider, _Component);

  var _super = (0, _rollupPluginBabelHelpersE84dd01a.c)(Provider);

  function Provider(props) {
    var _this;

    (0, _rollupPluginBabelHelpersE84dd01a.e)(this, Provider);
    _this = _super.call(this, props);
    var _this$props = _this.props,
        config = _this$props.config,
        _this$props$Rollbar = _this$props.Rollbar,
        ctor = _this$props$Rollbar === void 0 ? _rollbar.default : _this$props$Rollbar,
        instance = _this$props.instance;
    (0, _tinyInvariantEsmA43f84cc.i)(!instance || instance instanceof _rollbar.default, 'providing `instance` must be of type Rollbar');
    var options = typeof config === 'function' ? config() : config;
    var rollbar = instance || new ctor(options); // TODO: use isUncaught to filter if this is 2nd Provider added
    // unless customer wants that

    _this.state = {
      rollbar: rollbar,
      options: options
    };
    return _this;
  } // componentDidUpdate()


  (0, _rollupPluginBabelHelpersE84dd01a.d)(Provider, [{
    key: "render",
    value: function render() {
      var _ref;

      var _this$props2 = this.props,
          children = _this$props2.children,
          _this$props2$Rollbar = _this$props2.Rollbar,
          ctor = _this$props2$Rollbar === void 0 ? _rollbar.default : _this$props2$Rollbar;
      var _this$state = this.state,
          rollbar = _this$state.rollbar,
          options = _this$state.options;
      return /*#__PURE__*/_react.default.createElement(Context.Provider, {
        value: (_ref = {}, (0, _rollupPluginBabelHelpersE84dd01a._)(_ref, RollbarInstance, rollbar), (0, _rollupPluginBabelHelpersE84dd01a._)(_ref, BaseOptions, options), (0, _rollupPluginBabelHelpersE84dd01a._)(_ref, RollbarCtor, ctor), _ref)
      }, children);
    }
  }]);
  return Provider;
}(_react.Component);

exports.Provider = Provider;
(0, _rollupPluginBabelHelpersE84dd01a._)(Provider, "propTypes", {
  Rollbar: _propTypes.default.func,
  config: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]).isRequired,
  instance: _propTypes.default.instanceOf(_rollbar.default)
});